import { render, staticRenderFns } from "./BaseFullScreenAnimation.vue?vue&type=template&id=d5a6fa2c&scoped=true&"
import script from "./BaseFullScreenAnimation.vue?vue&type=script&lang=js&"
export * from "./BaseFullScreenAnimation.vue?vue&type=script&lang=js&"
import style0 from "./BaseFullScreenAnimation.vue?vue&type=style&index=0&id=d5a6fa2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../client_web_food_market/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5a6fa2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Administrator\\Desktop\\gtzn\\FreeGoShop\\client_web_food_market\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('d5a6fa2c', component.options)
    } else {
      api.reload('d5a6fa2c', component.options)
    }
    module.hot.accept("./BaseFullScreenAnimation.vue?vue&type=template&id=d5a6fa2c&scoped=true&", function () {
      api.rerender('d5a6fa2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "client_web_common/base_components/BaseFullScreenAnimation.vue"
export default component.exports